import { range } from 'lodash';
import { denormalize } from '@eb/transformation-utils';
import { USER_PROP_FIXTURE } from '@eb/site-header';
import {
    transformEvents,
    transformOrganizers,
    transformStatusCounts,
} from './utils';
import {
    DEFAULT_PAGE_NUMBER,
    DEFAULT_PAGE_SIZE,
    API_STATUS_CANCELED,
    API_STATUS_LIVE,
    API_STATUS_STARTED,
    API_STATUS_ENDED,
    API_STATUS_COMPLETED,
    API_STATUS_DRAFT,
    EVENT_SALES_STATUS_ON_SALE,
    EVENT_SALES_STATUS_SALES_ENDED,
    EVENT_SALES_STATUS_UNAVAILABLE,
} from './constants';

export const MOCK_ORGANIZATION_ID = USER_PROP_FIXTURE.publicId;
export const REQUEST_PROP_FIXTURE = {
    path: '/manage/events',
};
export const REQUEST_SSR_PROP_FIXTURE = {
    path: '/manage/events/all',
};
export const MOCK_BASE_URL = '/organizations';
export const MOCK_LOCATION_PROP = { pathname: MOCK_BASE_URL, query: {} };

export const MOCK_STATUS_COUNTS = {
    statusCounts: {
        published: 0,
        past: 0,
        draft: 0,
    },
};

const EVENT_NAMES = [
    'Holiday Party',
    'Pickling Workshop',
    'A Fun Concert',
    'Broadway Musical',
    'Boring Class',
];
const NUM_EVENTS = EVENT_NAMES.length;
const PERCENTAGE_TICKET_SALES = [0, 0.123, 0.456, 0.789, 1];
const DATES = [
    {
        start: {
            timezone: 'America/Los_Angeles',
            local: '2018-04-09T19:00:00',
            utc: '2018-04-10T02:00:00Z',
        },
        end: {
            timezone: 'America/Los_Angeles',
            local: '2018-04-09T22:00:00',
            utc: '2018-04-10T05:00:00Z',
        },
    },
    {
        start: {
            timezone: 'America/New_York',
            local: '2018-04-09T15:00:00',
            utc: '2018-04-10T19:00:00Z',
        },
        end: {
            timezone: 'America/New_York',
            local: '2018-04-10T01:00:00',
            utc: '2018-04-10T05:00:00Z',
        },
    },
    {
        start: {
            timezone: 'Europe/Paris',
            local: '2018-04-09T15:30:00',
            utc: '2018-04-09T13:30:00Z',
        },
        end: {
            timezone: 'Europe/Paris',
            local: '2018-04-13T17:45:00',
            utc: '2018-04-13T15:45:00Z',
        },
    },
    {
        start: {
            timezone: 'Asia/Magadan',
            local: '2018-04-09T15:30:00',
            utc: '2018-04-12T08:00:00Z',
        },
        end: {
            timezone: 'Asia/Magadan',
            local: '2018-04-14T02:45:00',
            utc: '2018-04-13T15:45:00Z',
        },
    },
    {
        start: {
            timezone: 'Africa/Johannesburg',
            local: '2018-04-13T11:00:00',
            utc: '2018-04-15T09:00:00Z',
        },
        end: {
            timezone: 'Africa/Johannesburg',
            local: '2018-04-14T02:45:00',
            utc: '2018-04-15T15:45:00Z',
        },
    },
];
const STATUSES = [
    API_STATUS_DRAFT,
    API_STATUS_LIVE,
    API_STATUS_STARTED,
    API_STATUS_ENDED,
    API_STATUS_COMPLETED,
    API_STATUS_CANCELED,
];
const NUM_STATUSES = STATUSES.length;

const SALES_STATUS_MAP = {
    [API_STATUS_DRAFT]: {
        sales_status: EVENT_SALES_STATUS_UNAVAILABLE,
        message: 'Unavailable',
        message_code: 'tickets_unavailable',
    },
    [API_STATUS_LIVE]: {
        sales_status: EVENT_SALES_STATUS_ON_SALE,
    },
    [API_STATUS_STARTED]: {
        sales_status: EVENT_SALES_STATUS_ON_SALE,
    },
    [API_STATUS_ENDED]: {
        sales_status: EVENT_SALES_STATUS_SALES_ENDED,
        message: 'Sales Ended',
        message_code: 'tickets_with_sales_ended',
    },
    [API_STATUS_COMPLETED]: {
        sales_status: EVENT_SALES_STATUS_SALES_ENDED,
        message: 'Sales Ended',
        message_code: 'tickets_with_sales_ended',
    },
    [API_STATUS_CANCELED]: {
        sales_status: EVENT_SALES_STATUS_SALES_ENDED,
        message: 'Canceled',
        message_code: 'event_cancelled',
    },
};

const _getMockSalesData = (index) => {
    const maxPossibleTicketSales = 123 * index + 87;
    const totalTicketSales = Math.ceil(
        PERCENTAGE_TICKET_SALES[index % PERCENTAGE_TICKET_SALES.length] *
            maxPossibleTicketSales,
    );
    let gross = '0';
    let net = '0';

    if (totalTicketSales) {
        gross = (totalTicketSales * 12.34).toFixed(2);
        net = (gross * 0.85).toFixed(2);
    }

    // simulate the case where a member doesn't have access to financials
    if (index % 6 === 4) {
        gross = null;
        net = null;
    }

    return {
        maxPossibleTicketSales,
        totalTicketSales,
        gross,
        net,
    };
};

const _getMockLogo = (index) => {
    let logo = null;

    if (index % 6 !== 3) {
        logo = {
            crop_mask: {
                top_left: {
                    x: 0,
                    y: 61,
                },
                width: 1984,
                height: 992,
            },
            original: {
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F41339916%2F246109779909%2F1%2Foriginal.jpg?s=6351b681230917001df9280ca1d6ab62',
                width: 1984,
                height: 1114,
            },
            id: '41339916',
            url:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F41339916%2F246109779909%2F1%2Foriginal.jpg?h=200&w=450&rect=0%2C61%2C1984%2C992&s=0e3ea5d04cb89b0161e51942c8bb8fb9',
            aspect_ratio: '2',
            edge_color: '#838560',
            edge_color_set: true,
        };
    }

    return logo;
};

const _getMockStatusInfo = (index) => {
    // applies binary combination logic to determine if the flag should be on
    // or off  based on the index and number of states
    // For example:
    // Level 1: off: 0 - 4 / on: 5 - 9 / off: 10 - 14 / on: 15 - 19 / etc
    // level 2: off: 0 - 9 / on: 10 - 19 / off: 20 - 29 / etc
    // level 3: off: 0 - 19 / on: 20 - 39 / etc
    const _shouldTurnOnBinaryCombination = (level) =>
        !!(Math.floor(index / NUM_STATUSES / Math.pow(2, level)) % 2);

    const status = STATUSES[index % NUM_STATUSES];
    const schedulePublishDate = _shouldTurnOnBinaryCombination(1)
        ? '2018-03-12T17:13:41Z'
        : null;
    const listed = _shouldTurnOnBinaryCombination(2);
    const inviteOnly = _shouldTurnOnBinaryCombination(3);
    let password;

    if (_shouldTurnOnBinaryCombination(4)) {
        password = 'foo';
    }

    return {
        status,
        event_sales_status: {
            start_sales_date: null,
            message_type: 'default',
            ...SALES_STATUS_MAP[status],
        },
        listed,
        password,
        invite_only: inviteOnly,
        publish_settings: {
            resource_uri:
                'https://www.evbdevapi.com/v3/events/3564388181/publish_settings/',
            published_date: null,
            schedule_publish_date: schedulePublishDate,
            schedule_publish_status: schedulePublishDate
                ? 'scheduled'
                : 'unscheduled',
            can_publish: !schedulePublishDate,
        },
    };
};

export const MOCK_VENUE = {
    address: {
        address_1: '4 Pennsylvania Plaza',
        address_2: null,
        city: 'New York',
        region: 'NY',
        postal_code: '10001',
        country: 'US',
        latitude: '40.75050450000001',
        longitude: '-73.99343870000001',
        localized_address_display: '4 Pennsylvania Plaza, New York, NY 10001',
        localized_area_display: 'New York, NY',
        localized_multi_line_address_display: [
            '4 Pennsylvania Plaza',
            'New York, NY 10001',
        ],
    },
    resource_uri: 'https://www.evbqaapi.com/v3/venues/23558605/',
    id: '23558605',
    age_restriction: null,
    capacity: null,
    name: 'Madison Square Garden',
    latitude: '40.75050450000001',
    longitude: '-73.99343870000001',
};

const _getMockVenueInfo = (index) => {
    const comboOption = index % 3;
    let onlineEvent = false;
    let venue = null;

    if (!comboOption) {
        venue = MOCK_VENUE;
    } else if (comboOption === 1) {
        onlineEvent = true;
    }

    return {
        venue,
        online_event: onlineEvent,
    };
};

/**
 *
 * @typedef MultipartText
 * @property {string} text
 * @property {string} html
 *
 * @typedef DateWithTimezone
 * @property {string} timezone
 * @property {string} local
 * @property {string} utc
 *
 * @typedef PaginationApiResponse
 * @property {number} object_count
 * @property {number} page_number
 * @property {number} page_size
 * @property {number} page_count
 * @property {boolean} has_more_items
 *
 * @typedef {'draft'|'canceled'|'live'|'started'|'ended'|'completed'} EventStatus
 * @typedef {'on_sale'|'not_yet_on_sale'|'sales_ended'|'sold_out'|'unavailable'} EventSalesStatus
 * @typedef {'default'|'custom'} EventSalesMessageType
 * @typedef {'tickets_with_sales_ended'|'tickets_at_the_door'|'tickets_unavailable'|'event_cancelled} EventSalesMessageCode
 *
 * @typedef ApiPublishSettings
 * @property {string} [published_date]
 * @property {string} [schedule_publish_date]
 * @property {'scheduled' | 'unscheduled'} schedule_publish_status
 * @property {boolean} can_publish
 *
 * @typedef ApiSalesStatusInfo
 * @property {string} start_sales_date
 * @property {EventSalesMessageType} message_type
 * @property {EventSalesStatus} sales_status
 * @property {string} message
 * @property {EventSalesMessageCode} message_code
 */
/**
 *
 * @typedef ApiEvent
 * @property {string} id
 * @property {MultipartText} name
 * @property {MultipartText} description
 * @property {string} url
 * @property {DateWithTimezone} start
 * @property {DateWithTimezone} end
 * @property {string} organization_id
 * @property {string} organizer_id
 * @property {EventStatus} status
 * @property {ApiSalesStatusInfo} event_sales_status
 * @property {boolean} listed
 * @property {string} [password]
 * @property {boolean} invite_only
 * @property {ApiPublishSettings} publish_settings
 *
 * @typedef EventsApiResponse
 * @property {PaginationApiResponse} pagination
 * @property {ApiEvent[]} events
 */
/**
 * Retrieves a mock events API response with the specified number of events
 * @param {string} organizationId Organization ID
 * @param {number} [numEvents=6] Number of events to retrieve
 * @param {string} [nameSuffix=''] A suffix to add to mock event name
 * @returns {EventsApiResponse}
 */
export const getMockEventsResponse = (
    organizationId = MOCK_ORGANIZATION_ID,
    numEvents = 6,
    nameSuffix = '',
) => {
    const pageCount = Math.ceil(numEvents / DEFAULT_PAGE_SIZE);

    return {
        pagination: {
            object_count: numEvents,
            page_number: DEFAULT_PAGE_NUMBER,
            page_size: DEFAULT_PAGE_SIZE,
            page_count: pageCount,
            has_more_items: pageCount > 1,
        },
        events: range(numEvents).map((index) => {
            const eventNum = index + 1;
            const eventId = `${1003 * eventNum}`;
            const eventName = EVENT_NAMES[index % NUM_EVENTS];
            const mockSalesData = _getMockSalesData(index);
            const dateInfo = DATES[index % DATES.length];
            const isSeries = eventNum === 1;
            let seriesExtras;

            if (isSeries) {
                seriesExtras = {
                    seriesId: eventId,
                    upcomingEvent: { ...dateInfo },
                };
            }

            return {
                name: {
                    text: `${eventName} #${eventNum}${nameSuffix}`,
                    html: `${eventName} #${eventNum}${nameSuffix}`,
                },
                description: {
                    text: `Summary for the event #${eventNum}`,
                    html: `Summary for the event #${eventNum}`,
                },
                id: eventId,
                url: `https://www.evbdev.com/e/test-event-tickets-${eventId}`,
                ...dateInfo,
                organization_id: organizationId,
                created: '2018-02-28T23:26:58Z',
                changed: '2018-02-28T23:26:58Z',
                capacity: mockSalesData.maxPossibleTicketSales,
                capacity_is_custom: false,
                ..._getMockStatusInfo(index),
                currency: 'USD',
                shareable: false,
                show_remaining: false,
                tx_time_limit: 480,
                hide_start_date: false,
                hide_end_date: false,
                locale: 'en_US',
                is_locked: false,
                privacy_setting: 'unlocked',
                is_series: isSeries,
                is_series_parent: isSeries,
                is_reserved_seating: false,
                source: index % 2 ? 'create_2.0' : 'coyote',
                is_free: !!(index % 2),
                version: '3.7.0',
                logo_id: null,
                organizer_id: '16897864814',
                venue_id: '23443010',
                category_id: null,
                subcategory_id: null,
                format_id: null,
                resource_uri: `https://www.evbdevapi.com/v3/events/${eventId}/`,
                is_externally_ticketed: eventNum === 6,
                logo: _getMockLogo(index),
                ..._getMockVenueInfo(index),
                sales_data_with_null: isSeries ? undefined : mockSalesData,
                ...seriesExtras,
            };
        }),
    };
};

/**
 * Returns the specified number of mock API events
 * @param {string} organizationId Organization ID
 * @param {number} [numEvents=6] Number of events to retrieve
 * @param {string} [nameSuffix=''] A suffix to add to mock event name
 * @returns {ApiEvent[]}
 */
export const getMockEvents = (
    organizationId = MOCK_ORGANIZATION_ID,
    numEvents = 6,
    nameSuffix = '',
) => getMockEventsResponse(organizationId, numEvents, nameSuffix).events;

/**
 * Returns the specified number of mock events, normalized into entities and ID.
 * All of the properties are converted to camelCase
 * @param {string} organizationId Organization ID
 * @param {number} [numEvents=6] Number of events to retrieve
 * @param {string} [nameSuffix=''] A suffix to add to mock event name
 */
export const getMockNormalizedEvents = (
    organizationId = MOCK_ORGANIZATION_ID,
    numEvents = 6,
    nameSuffix = '',
) => transformEvents(getMockEvents(organizationId, numEvents, nameSuffix));

/**
 * Returns the specified number of mock events in the denomarlized format passed to components.
 * All of the properties have been converted to camelCase.
 * @param {string} organizationId Organization ID
 * @param {number} [numEvents=6] Number of events to retrieve
 * @param {string} [nameSuffix=''] A suffix to add to mock event name
 */
export const getMockDenormalizedEvents = (
    organizationId = MOCK_ORGANIZATION_ID,
    numEvents = 6,
    nameSuffix = '',
) => {
    const { eventIds, eventEntities } = getMockNormalizedEvents(
        organizationId,
        numEvents,
        nameSuffix,
    );

    return denormalize(eventIds, eventEntities);
};

const ORGANIZER_NAMES = [
    'Awesome Events',
    'Amazing Conferences',
    'Fun Races',
    'Good Eats',
];
const NUM_ORGANIZERS = ORGANIZER_NAMES.length;

/**
 *
 * @typedef ApiOrganizer
 * @property {string} id
 * @property {string} name
 * @property {MultipartText} description
 * @property {MultipartText} long_description
 * @property {string} url
 * @property {string} logo_id
 * @property {Number} num_past_events
 * @property {Number} num_future_events
 * @property {string} organization_id
 * @property {string} resource_uri
 *
 * @typedef OrganizersApiResponse
 * @property {PaginationApiResponse} pagination
 * @property {ApiOrganizer[]} organizers
 */
/**
 * Retrieves a mock organizers API response with the specified number of organizers
 * @param {string} organizationId Organization ID
 * @param {number} [numOrganizers=6] Number of organizers to retrieve
 * @returns {OrganizersApiResponse}
 */
export const getMockOrganizersResponse = (
    organizationId = MOCK_ORGANIZATION_ID,
    numOrganizers = 6,
) => {
    const pageCount = Math.ceil(numOrganizers / DEFAULT_PAGE_SIZE);

    return {
        pagination: {
            object_count: numOrganizers,
            page_number: DEFAULT_PAGE_NUMBER,
            page_size: DEFAULT_PAGE_SIZE,
            page_count: pageCount,
            has_more_items: pageCount > 1,
        },
        organizers: range(numOrganizers).map((index) => {
            const organizerNum = index + 1;
            const organizerId = `${1007 * organizerNum}`;
            const organizerName = ORGANIZER_NAMES[index % NUM_ORGANIZERS];

            return {
                id: organizerId,
                name:
                    organizerNum === 1
                        ? null
                        : `${organizerName} #${organizerNum}`,
                description: {
                    text: `Summary for the organizer #${organizerNum}`,
                    html: `Summary for the organizer #${organizerNum}`,
                },
                long_description: {
                    text: `Super long summary for the organizer #${organizerNum}`,
                    html: `Super long summary for the organizer #${organizerNum}`,
                },
                url: `https://www.evbdev.com/o/${organizerId}`,
                logo_id: null,
                num_past_events: 0,
                num_future_events: 0,
                organization_id: organizationId,
                resource_uri: `https://www.evbdevapi.com/v3/organizers/${organizerId}/`,
            };
        }),
    };
};

/**
 * Returns the specified number of mock API organizers
 * @param {string} organizationId Organization ID
 * @param {number} [numOrganizers=6] Number of organizers to retrieve
 * @returns {ApiOrganizer[]}
 */
export const getMockOrganizers = (
    organizationId = MOCK_ORGANIZATION_ID,
    numOrganizers = 6,
) => getMockOrganizersResponse(organizationId, numOrganizers).organizers;

/**
 * Returns the specified number of mock organized, normalized into entities and ID.
 * All of the properties are converted to camelCase
 * @param {string} organizationId Organization ID
 * @param {number} [numOrganizers=6] Number of organizers to retrieve
 */
export const getMockNormalizedOrganizers = (
    organizationId = MOCK_ORGANIZATION_ID,
    numOrganizers = 6,
) => transformOrganizers(getMockOrganizers(organizationId, numOrganizers));

/**
 * Returns the specified number of mock organizers in the denomarlized format passed to components.
 * All of the properties have been converted to camelCase.
 * @param {string} organizationId Organization ID
 * @param {number} [numOrganizers=6] Number of organizers to retrieve
 */
export const getMockDenormalizedOrganizers = (
    organizationId = MOCK_ORGANIZATION_ID,
    numOrganizers = 6,
) => {
    const { organizerIds, organizerEntities } = getMockNormalizedOrganizers(
        organizationId,
        numOrganizers,
    );

    return denormalize(organizerIds, organizerEntities);
};

/**
 * Retrieves a mock status counts API response with some sample status counts
 * @returns {StatusCountsApiResponse}
 */
export const getMockStatusCountsResponse = (organization_id) => ({
    event_count: {
        current_future_published: 0,
        draft: 3,
        past_published: 2,
    },
});
